import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";
 const CargoCompanyList=()=>request({
  url: ApiURL.Query.CompanyList,
  method: RequestType.GET,
 });
 const GetDistanceTypeList=()=>request({
  url: ApiURL.Query.GetDistanceType,
  method: RequestType.GET,
 });
  const DepartureLocationTypeList=()=>request({
  url: ApiURL.Query.DepartureLocationType,
  method: RequestType.GET,
 });
 const GetFilteredShippingCompanyPrices=(data:any)=>request({
  url: ApiURL.Query.GetFilteredShippingCompanyPrices,
  method: RequestType.POST,
  data 
});


 const CargoFeeManagementQuery = {
  CargoCompanyList,  
  GetDistanceTypeList,
  DepartureLocationTypeList,
  GetFilteredShippingCompanyPrices
};

export default CargoFeeManagementQuery;